export interface ParsedTrigger {
  mouseenter: boolean;
  mousemove: boolean;
  focus: boolean;
  click: boolean;
}

// Parse a space-separated trigger string (e.g. "mouseenter focus") into discrete event-token
// flags. When unset, default to hover (mouseenter) + focus. Consumers compose these into the
// Floating UI interactions they support: a tooltip treats mousemove as hover for cursor-following,
// while a menu maps click to a toggle.
export function parseTrigger(trigger?: string): ParsedTrigger {
  if (trigger == null) return { mouseenter: true, mousemove: false, focus: true, click: false };
  return {
    mouseenter: trigger.includes('mouseenter'),
    mousemove: trigger.includes('mousemove'),
    focus: trigger.includes('focus'),
    click: trigger.includes('click'),
  };
}
